import "core-js/modules/es.array.push.js";
import "core-js/modules/es.error.cause.js";
import { openBlock as v, createElementBlock as g, createElementVNode as B, Fragment as D, renderList as S, normalizeClass as j, renderSlot as y, createTextVNode as O, toDisplayString as R, createCommentVNode as T, ref as f, computed as z, watch as K, onMounted as G, createVNode as U, unref as _, createSlots as k, withCtx as P, normalizeProps as H, guardReactiveProps as J } from "vue";
import { CdrInput as Q } from "@rei/cedar";
const M = (a, c) => {
  const t = a.__vccOpts || a;
  for (const [u, r] of c)
    t[u] = r;
  return t;
}, W = {
  key: 0,
  class: "autocomplete-list"
}, X = {
  class: "autocomplete-item"
}, Y = ["data-ui", "onMousedown"], Z = {
  name: "AutocompleteList"
}, ee = /* @__PURE__ */ Object.assign(Z, {
  props: {
    matchProperty: {
      type: String,
      default: null
    },
    matches: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: -1
    },
    focused: {
      type: Boolean,
      default: !1
    },
    debug: {
      type: Boolean,
      requred: !1
    }
  },
  emits: ["mouse-selected-index"],
  setup(a, {
    emit: c
  }) {
    function t(u) {
      c("mouse-selected-index", u);
    }
    return (u, r) => a.focused && a.matches && a.matches.length > 0 || a.debug ? (v(), g("ul", W, [B("li", X, [(v(!0), g(D, null, S(a.matches, (l, o) => (v(), g("button", {
      key: `match-${o}`,
      type: "button",
      tabindex: "-1",
      class: j({
        active: o === a.activeIndex
      }),
      "data-ui": `autocomplete-suggestion-${o}`,
      onMousedown: (m) => t(o)
    }, [y(u.$slots, "match", {
      match: l
    }, () => [O(R(a.matchProperty && l[a.matchProperty] ? l[a.matchProperty] : l), 1)], !0)], 42, Y))), 128))])])) : T("", !0);
  }
}), te = /* @__PURE__ */ M(ee, [["__scopeId", "data-v-140ba123"]]), ae = (a, c) => {
  let t;
  return (...u) => {
    clearTimeout(t), t = setTimeout(() => a(...u), c);
  };
};
const ue = {
  class: "autocomplete"
}, oe = {
  class: "autocomplete-container"
}, le = {
  name: "AutocompleteInput"
}, ne = /* @__PURE__ */ Object.assign(le, {
  props: {
    inputId: {
      type: String,
      default: null
    },
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    suggestions: {
      type: Array,
      default: () => []
    },
    maxSuggestions: {
      type: Number,
      required: !1,
      default: 5
    },
    fetchUrl: {
      type: [String, Function],
      default: ""
    },
    matchProperty: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: !0
    },
    hideLabel: {
      type: Boolean,
      required: !1
    },
    autofocus: {
      type: Boolean,
      required: !1
    },
    dataUi: {
      type: String,
      default: null
    },
    delay: {
      type: Number,
      required: !1,
      default: 100
    },
    debug: {
      type: Boolean,
      required: !1
    },
    autocomplete: {
      type: String,
      required: !1,
      default: "off"
    }
  },
  emits: ["autocomplete-change", "autocomplete-selected-data", "clear-autocomplete-selection", "autocomplete-submit", "autocomplete-focus"],
  setup(a, {
    emit: c
  }) {
    const t = a, u = f(-1), r = f(!1), l = f(V(t.modelValue)), o = f(t.modelValue), m = f(null), x = f(t.modelValue), b = z(() => {
      if (t.fetchUrl && t.matchProperty && l.value) {
        const e = [];
        return l.value.forEach((s) => {
          s[t.matchProperty] && e.push(s[t.matchProperty]);
        }), e;
      }
      return l.value;
    });
    K(() => t.modelValue, (e) => {
      x.value = o.value, o.value = e;
    });
    let p = (e) => {
      x.value !== e && (c("autocomplete-change", o.value), c("clear-autocomplete-selection"), $(o.value));
    };
    G(() => {
      p = t.delay ? ae(p.bind(this), t.delay) : p;
    });
    function q(e) {
      if (!e) {
        m.value = null, l.value = [];
        return;
      }
      I();
      const s = typeof t.fetchUrl == "function" ? t.fetchUrl(e) : `${t.fetchUrl}/${encodeURIComponent(e)}`, d = fetch(s).then((n) => {
        if (n.ok)
          return n.json();
        throw new Error();
      }).then((n) => {
        if (d !== m.value)
          return;
        const i = [];
        for (let h = 0; h < n.length && h < t.maxSuggestions; h += 1) {
          const N = n[h];
          i.push(N);
        }
        l.value = i;
      }).catch(() => {
      });
      return m.value = d, d;
    }
    function V(e) {
      const s = [];
      if (e && t.suggestions) {
        const d = new RegExp(e, "i");
        for (let n = 0; n < t.suggestions.length && s.length < t.maxSuggestions; n += 1) {
          const i = t.suggestions[n];
          d.test(i) && s.push(i);
        }
      }
      return s;
    }
    function $(e) {
      t.fetchUrl ? q(e) : l.value = V(e);
    }
    function I() {
      u.value = -1;
    }
    function w() {
      c("autocomplete-change", o.value), c("autocomplete-selected-data", l.value[u.value]);
    }
    function C(e) {
      o.value = b.value[e] || "", u.value = e, w(), I(), r.value = !1;
    }
    function L(e) {
      if (l.value)
        switch (e.key) {
          case "ArrowUp":
          case "Up": {
            u.value > -1 && (r.value = !0, u.value -= 1, A(u.value));
            break;
          }
          case "ArrowDown":
          case "Down": {
            u.value < l.value.length - 1 && (r.value = !0, u.value += 1, A(u.value));
            break;
          }
          case "Enter":
            u.value > -1 ? (e.preventDefault(), o.value = b.value[u.value] || "", w()) : c("autocomplete-submit"), I(), r.value = !1;
            break;
          default:
            r.value = !0;
            break;
        }
    }
    function F() {
      r.value = !1, c("autocomplete-focus", !1);
    }
    function E() {
      u.value = -1, $(o.value), r.value = !0, c("autocomplete-focus", !0);
    }
    function A(e) {
      o.value = b.value[e] || "";
    }
    return (e, s) => (v(), g("div", ue, [B("div", oe, [U(_(Q), {
      id: a.inputId,
      ref: "i",
      modelValue: o.value,
      "onUpdate:modelValue": s[0] || (s[0] = (d) => o.value = d),
      class: "autocomplete-input",
      type: "text",
      autocomplete: a.autocomplete,
      autofocus: a.autofocus,
      "hide-label": a.hideLabel,
      label: a.label,
      "data-ui": a.dataUi,
      placeholder: a.placeholder,
      onInput: _(p),
      onKeydown: L,
      onBlur: F,
      onFocus: E
    }, k({
      _: 2
    }, [S(e.$slots, (d, n) => ({
      name: n,
      fn: P(() => [y(e.$slots, n, {}, void 0, !0)])
    }))]), 1032, ["id", "modelValue", "autocomplete", "autofocus", "hide-label", "label", "data-ui", "placeholder", "onInput"]), y(e.$slots, "default", {}, void 0, !0)]), U(te, {
      debug: a.debug,
      focused: r.value,
      matches: l.value,
      "match-property": a.matchProperty,
      "active-index": u.value,
      onMouseSelectedIndex: C
    }, k({
      _: 2
    }, [S(e.$slots, (d, n) => ({
      name: n,
      fn: P((i) => [y(e.$slots, n, H(J(i)), void 0, !0)])
    }))]), 1032, ["debug", "focused", "matches", "match-property", "active-index"])]));
  }
}), ie = /* @__PURE__ */ M(ne, [["__scopeId", "data-v-41bfa046"]]);
export {
  ie as default
};
